export default __webpack_public_path__ + "static/media/user-2.030e47cc.png";